import React from 'react';
import PropTypes from 'prop-types';
import Select, { selectType } from 'Components/Select';
import Text from 'Components/Text';
import { ACTION } from 'constants/index';

export default class Row extends React.Component {
  _selectAction = actionKey => {
    const { brand, selectAction, updateListEntry, deleteListEntry } = this.props;

    selectAction(actionKey, brand).then(updatedData => {
      if (actionKey !== ACTION.DELETE) updateListEntry(brand, updatedData);
      else deleteListEntry(brand);
    });
  };

  _getStatusColor = () => {
    const { brand } = this.props;

    if (brand && brand.applicationStatus) {
      return `list-scene__status-label_${brand.applicationStatus.toString().toLowerCase()}`;
    }
    return '';
  };

  _getFormulaReadableStatus = () => {
    const { brand } = this.props;

    if (brand && brand.applicationStatus) {
      return brand.applicationStatus[0].toUpperCase() + brand.applicationStatus.slice(1).toLowerCase();
    }

    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;
    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  render() {
    const { brand, availableActionsList } = this.props;

    return (
      <div
        id={`brandRowId${brand.number}`}
        className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}
        onClick={() => {
          this._selectAction(ACTION.DETAILS);
        }}
      >
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='brandNumberField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'number'
          )} _width_pc_12`}
        >
          {brand.number || 'N/A'}
        </div>

        <div
          id='brandNameField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'name'
          )} _width_pc_22`}
        >
          {brand.name}
        </div>

        <div
          id='brandBaseOilFormulaNumberField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'formulaBaseOilNumber'
          )} _width_pc_12`}
        >
          {brand.formulaBaseOilNumber}
        </div>

        <div
          id='brandEngineTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'formulaEngineType'
          )} _width_pc_10`}
        >
          {brand.formulaEngineType}
        </div>

        <div
          id='brandYearField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'year'
          )} _width_pc_8`}
        >
          {brand.year}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <div
            id='brandStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle(
              'applicationStatus'
            )}`}
          >
            {this._getFormulaReadableStatus()}
          </div>
        </div>

        <div
          id='brandFeeStatusField'
          className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'
        >
          <Text
            mainWrapperClassName='text__wrapper_primary _width_90 _margin_0'
            textClassName={`text__binary-status-text ${
              brand.isPaid ? 'true' : 'false'
            } _margin_0 ${this._getTextColourStyle('isPaid')}`}
            value={brand.isPaid ? 'Paid' : 'Unpaid'}
          />
        </div>

        <div
          id='brandActionsField'
          className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'
        >
          <Select
            placeholder='Actions'
            selectionList={availableActionsList}
            multiSelect
            handleSelect={this._selectAction}
            type={selectType.listActions}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  brand: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  zIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/List/Row.jsx